import {z as r} from 'zod';

/**
 * Admin help link: urlPattern = ^feature-flag-review-realtime$
 *
 * Pilot:
 * { "counterpartyIds": [28953, 32337, 35500, 140782, 29119, 30667, 28946, 28951], "staffCanSend": false }
 *
 * Rollout for all:
 * { "available": true, "staffCanSend": false }
 */
const reviewRealtimeHelpLinkConfigSchema = r
    .object({
        available: r.boolean().optional(),
        counterpartyIds: r.array(r.number()).optional(),
        staffCanSend: r.boolean().optional(),
    })
    .refine((data) => data.available === true || (data.counterpartyIds?.length ?? 0) > 0, {
        message: 'Either available:true or non-empty counterpartyIds is required',
    });

export type ReviewRealtimeHelpLinkConfigType = r.infer<typeof reviewRealtimeHelpLinkConfigSchema>;

export function parseReviewRealtimeHelpLinkConfig(config: unknown): ReviewRealtimeHelpLinkConfigType | null {
    const parseResult = reviewRealtimeHelpLinkConfigSchema.safeParse(config);

    if (!parseResult.success) {
        return null;
    }

    return parseResult.data;
}
